'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var rightPath = ['M27-10h-40v40h40z', 'M.68 2.333L3.01 0 13 10 3.01 20 .68 17.667 8.338 10z'];

exports["default"] = rightPath;
